
import { addLocale, setLocale } from '@umijs/max';
import SvgLang from '@svg/lang'
import { ENV } from '@/common/config';
import local from './zh-CN.json'

function getValueFromSearchParams(key: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}
const isOversea = (!getValueFromSearchParams('oversea') && !!getValueFromSearchParams('lang') && getValueFromSearchParams('lang') !== 'zh-CN') || window.location.hostname.indexOf('aihouse') > -1 || !!(getValueFromSearchParams('oversea') && getValueFromSearchParams('oversea') === 'true');

export const svgLang: any = new SvgLang({ env: ENV, isAihouse: isOversea });

const queryLang = new URLSearchParams(window.location.search).get('lang')
const urllang = queryLang?.replace?.('_', '-')
export const lang = urllang || await svgLang.getLocale();
console.log('lang', lang)
//设置国际化数据
export const loadLanguageAsync = async () => {
  let langInfo = await svgLang?.getRemoteLang?.({
    acceptLanguage: lang,
    packageCode: "MaterialUi"
  })
  const newLangInfo = {
    ...local,
    ...langInfo
  }
  addLocale("zh-CN", newLangInfo, {
    momentLocale: '',
    antd: ''
  })
  setLocale("zh-CN", false);
}


